<script setup lang="ts">
  import { ref } from 'vue';
  import { secondsToHoursAndMinutes } from '@/utils/item-printer.ts';
  import { AttendanceMonthDto } from '@/services/api/attendance-month-api.ts';

  const props = defineProps<{
    attendanceMonth: AttendanceMonthDto;
    workTime: number;
    vacationTime: number;
  }>();

  const contractWorkTime = props.attendanceMonth.contractWorkHour * 3600;
  const statutoryWorkTime = props.attendanceMonth.statutoryWorkHour * 3600;
  const maxWorkingTime =
    statutoryWorkTime + props.attendanceMonth.maxExtraWorkHour * 3600;
  const workTime = props.workTime;
  const vacationTime = props.vacationTime;

  const progressStyle = ref<string>('background-color: #ededed');
  const contractWorkText = ref('');
  const contractWorkStyle = ref('');
  const vacationText = ref('');
  const vacationStyle = ref('');

  /** 법정 근로 시간 */
  // const statutoryWorkText = ref('');
  // const statutoryWorkStyle = ref('');

  /** 최대 근로 시간 */
  // const maxWorkingText = ref('');
  // const maxWorkingPerStyle = ref('');

  /** 연장 근무 시간 : 법정 + 최대를 합쳐 표시 */
  const extraWorkedTimeText = ref('');
  const extraWorkedTimePerStyle = ref('');

  if (workTime <= contractWorkTime) {
    const totalTime = contractWorkTime + vacationTime;
    progressStyle.value = 'background-color: rgba(92, 184, 92, 0.4)';
    contractWorkText.value = `${secondsToHoursAndMinutes(workTime)}`;

    const contractWorkPer = Math.round((workTime / totalTime) * 100);
    contractWorkStyle.value = `width: ${contractWorkPer}%`;

    if (vacationTime) {
      vacationText.value = `${secondsToHoursAndMinutes(vacationTime)}`;
      const vacationPer = Math.round((vacationTime / totalTime) * 100);
      vacationStyle.value = `width: ${vacationPer}%`;
    }
  } else {
    const totalTime = maxWorkingTime + vacationTime;

    progressStyle.value = 'background-color: rgba(240, 173, 78, 0.4)';
    contractWorkText.value = `${secondsToHoursAndMinutes(contractWorkTime)}`;
    const contractWorkPer = Math.round((contractWorkTime / totalTime) * 100);
    contractWorkStyle.value = `width: ${contractWorkPer}%`;

    const vacationPer = Math.round((vacationTime / totalTime) * 100);
    if (vacationPer) {
      vacationText.value = `${secondsToHoursAndMinutes(vacationTime)}`;
      vacationStyle.value = `width: ${vacationPer}%`;
    }

    extraWorkedTimeText.value = `${secondsToHoursAndMinutes(
      workTime - contractWorkTime
    )}`;
    const extraWorkPer = Math.round(
      ((workTime - contractWorkTime) / totalTime) * 100
    );
    extraWorkedTimePerStyle.value = `width: ${extraWorkPer}%`;
  }
</script>

<template>
  <div
    class="pg"
    :style="progressStyle">
    <div
      v-if="contractWorkText"
      class="pg-bar pg-bar-contract"
      :style="contractWorkStyle">
      <div>의무</div>
      {{ contractWorkText }}
    </div>

    <div
      v-if="vacationText"
      class="pg-bar pg-bar-vacation"
      :style="vacationStyle">
      <div>휴가</div>
      {{ vacationText }}
    </div>

    <div
      v-if="extraWorkedTimeText"
      class="pg-bar pg-bar-statutory"
      :style="extraWorkedTimePerStyle">
      <div>연장</div>
      {{ extraWorkedTimeText }}
    </div>
  </div>
</template>

<style scoped lang="scss">
  .pg {
    height: 45px;
    overflow: hidden;
    background-color: rgba(92, 184, 92, 0.4);
    border-radius: 6px;

    .pg-bar {
      float: left;
      width: 0;
      padding: 3px;
      height: 100%;
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: #fff;
      text-align: center;
      background-color: #337ab7;
      -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
      box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
      -webkit-transition: width 0.6s ease;
      -o-transition: width 0.6s ease;
      transition: width 0.6s ease;
    }

    .pg-bar-contract {
      background-color: rgba(92, 184, 92, 1);
    }

    .pg-bar-vacation {
      background-color: rgba(128, 128, 128, 1);
    }

    .pg-bar-statutory {
      background-color: rgba(240, 173, 78, 1);
    }

    .pg-bar-maxWorking {
      background-color: rgba(217, 83, 79, 1);
    }
  }
</style>
